// extracted by mini-css-extract-plugin
module.exports = {"video":"style_video__2gQVY"};